<script>
    import {jsPlumb} from 'jsplumb';

    export default {
        name: 'drag-and-drop-wrapper',
        created() {
            const vm = this;
            
            const el = vm.$el;
            
            jsPlumb.ready(() => {
                const jsPlumbInstance = jsPlumb.getInstance();
                
                jsPlumbInstance.setContainer(el);

                vm.jsPlumbInstance = jsPlumbInstance;
                vm.isReady = true;
            });
        },
        render(createElement, context) {
            const vm = this;

            //Render nothing until our instance becomes ready
            if(!vm.isReady){
                return createElement('template');
            }
            
            return vm.$scopedSlots.default({
                jsPlumbInstance: vm.jsPlumbInstance
            });
        },
        data: () => ({
            isReady: false,
            jsPlumbInstance: null
        })
    }
</script>